import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useUpdateLine = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.put("/Line/UpdateLine", formData);
  });
  return mutation;
};
export default useUpdateLine;
